import { basename } from "../Config"

const UrlResolver =(url)=>{
    if(basename === ""){
        return `/${url}`
    }else{
        return `/${basename}/${url}`
    }
}

export default UrlResolver